export const USER_TYPE = {
  EXTERNAL: "external", // outside network
  INTERNAL: "internal", // inside network
  AUTHENTICATED: "authenticated", // has a valid JWT
};

export const UB_DASHBOARD_FILTER_TYPE = {
  RELATIVE: "relative",
  DATE_RANGE: "date_range",
  DATE_TIME_RANGE: "date_time_range"
}

export const DOWN_DETECTOR_TIME_RANGE = {
  CUSTOM: "custom",
  TODAY: "today",
  YESTERDAY: "yesterday",
  DAYS_7: "days_7",
  DAYS_30: "days_30"
};

export const DOWN_DETECTOR_TIME_INTERVAL = {
  ANY: "any",
  MINUTES_01: "01_minutes",
  MINUTES_05: "05_minutes",
  MINUTES_15: "15_minutes",
  MINUTES_30: "30_minutes",
  HOURS_01: "01_hours",
  DAYS_01: "01_days",
};

export const DOWN_DETECTOR_CHART_TYPE = {
  AREA: "area",
  BAR: "bar",
  LINE: "line"
};

export const LOG_USAGE_PERIOD = {
  HOURLY: "hourly",
  DAILY: "daily",
  MONTHLY: "monthly",
}

export const AMAZON_CATEGORY_ORDER = [
  'olb',
  'spend_management',
  'acquisition',
  'usb_api',
  'partner_api',
];

export const AMAZON_SUBCATEGORY_ORDER = [
  'Login',
  'Customer Dashboard',
  'Account Dashboard',
  'User Management',
  'Expense Management',
  'Payments',
  'Card Services',
  'Alerts',
  'Rewards & Benefits',
  'Statements',
  'Transactions',
];
